export default function (globalCount) {
  let filterRoot = $(".grid--filter");

  if (globalCount) {
    loadMore();
  }

  let filters = $(".filter-item")
    .map(function () {
      return $(this).data("key");
    })
    .get();

  $(".trigger-filter").on("click", () => {
    $(".grid--filter__inner").toggleClass("open");
  });

  $(".clear-filter").on("click", () => {
    for (let index = 0; index < filters.length; index++) {
      const filter = filters[index];
      filterRoot.attr(`data-${filter}`, "");
    }
    $(".filter-item__option.selected").removeClass("selected");
    $(".filter-cat").removeClass("show");
    filterResults();
  });

  $(".filter-item__option").on("click", function () {
    $(this).toggleClass("selected");

    let filterArrays = [];
    for (let index = 0; index < filters.length; index++) {
      const filter = filters[index];
      filterArrays.push({ el: filter, arr: new Array() });
    }

    for (let index = 0; index < filterArrays.length; index++) {
      const filter = filterArrays[index];
      $(`#filter_${filter.el} .filter-item__option.selected`).each(function () {
        let val = $(this).attr("data-value");
        filter.arr.push(val);
      });
      filterRoot.attr(`data-${filter.el}`, filter.arr.join());
      if (filter.arr.length) {
        $(`.filter-cat[data-clear=${filter.el}]`).addClass("show");
      } else {
        $(`.filter-cat[data-clear=${filter.el}]`).removeClass("show");
      }
    }

    filterResults();
  });

  $(".filter-item__search input").on("keyup", function () {
    let val = $(this).val();
    val = !val ? "" : val.replace(/[^a-zA-Z ]/g, "").toLowerCase();
    let track = $(".filter-item__track");
    if (val.length > 0) {
      track.find(".filter-item__option").addClass("hidden");
      track.find(".filter-item__option").each(function () {
        let title = $(this)
          .attr("title")
          .replace(/[^a-zA-Z ]/g, "")
          .toLowerCase();
        if (title.includes(val)) {
          $(this).removeClass("hidden");
        }
      });
    } else {
      track.find(".filter-item__option").removeClass("hidden");
    }
  });

  $(".filter-cat").on("click", function () {
    filterRoot.attr(`data-${$(this).data("clear")}`, "");
    $(
      `#filter_${$(this).data("clear")} .filter-item__option.selected`
    ).removeClass("selected");
    $(this).removeClass("show");
    filterResults();
  });

  function filterResults() {
    if (globalCount) {
      $(".reviews--grid--item.in-view").removeClass("in-view");
      $(".load-more p").html("See more reviews");
    }
    let count = 0;
    $(".r-total").html(count);

    let items = $(".grid-filterable");
    let filterArrays = [];
    for (let index = 0; index < filters.length; index++) {
      const filter = filters[index];
      filterArrays.push({
        el: filter,
        arr: filterRoot.attr(`data-${filter}`)
          ? filterRoot.attr(`data-${filter}`).split(",")
          : [],
      });
    }

    items.addClass("hidden");
    items.each(function () {
      let totalMatch = true;
      for (let fx = 0; fx < filterArrays.length; fx++) {
        const filterX = filterArrays[fx];
        let match = false;
        if (filterX.arr.length > 0) {
          if (filterX.el === "times") {
            let cc = $(this).attr("data-time");
            let reviewTime = Date.parse(cc);
            let filterTime = Date.parse(filterX.arr[0]);
            if (filterTime <= reviewTime) {
              match = true;
            }
          } else {
            let cc = $(this).attr(`data-${filterX.el}`).split(",");
            for (let i = 0; i < cc.length; i++) {
              if (filterX.arr.includes(cc[i])) {
                match = true;
              }
            }
          }
        } else {
          match = true;
        }
        if (totalMatch && !match) totalMatch = false;
      }

      if (totalMatch) {
        $(this).removeClass("hidden");
        count++;
        $(".r-total").html(count);
      }
    });

    if (count > 0) {
      $(".trip-calendar--no-results").removeClass("show");
    } else {
      $(".trip-calendar--no-results").addClass("show");
    }

    if (globalCount) {
      globalCount = 10;
      loadMore();
    }
  }

  function loadMore() {
    $("body").addClass("no-load");
    let reviewBase = $(".reviews--grid--view");
    for (let i = 0; i < globalCount; i++) {
      let next = reviewBase
        .find(".reviews--grid--item:not(.hidden):not(.in-view)")
        .first();
      if (!next.length > 0) {
        console.log("Break loop"); //eslint-disable-line
        $(".load-more p").html("No more reviews to show");
        break;
      } else {
        next.addClass("in-view");
      }
    }

    setTimeout(() => {
      $("body").removeClass("no-load");
    }, 1000);
  }

  $(".preselect").trigger("click");

  filterResults();
}



// WEBPACK FOOTER //
// ./scripts/util/gridFilter.js